import { NavLink, useNavigate } from 'react-router-dom';
import React, {useState, useEffect } from 'react';


import '@fortawesome/fontawesome-free/css/all.min.css';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;

const Plans = () => {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);

return (

<div className="plans_wrapper">
	<div className="plans_mainsec">
		<div className="container">
			<div className="row">
				<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
					<div className="price_contnt">
						<h1 className="gradienttxt">Premium Telegram Channel – Coming Soon!</h1>
						<p>Get ready to unlock exclusive crypto insights like never before. Our Premium Telegram Channel is designed for serious traders, investors, and enthusiasts who want real-time market updates, expert trading signals, in-depth analysis, and early access to opportunities before they go mainstream.</p>
						
						<h2>Perks of Joining Our Premium Telegram Channel</h2>
						
						<ul>
							<li><strong>Exclusive Trading Signals –</strong> High-accuracy buy & sell alerts to help you trade smarter.</li>
							<li><strong>Advanced Market Analysis –</strong> Deep dives into crypto trends, price action, and key levels.</li>
							<li><strong>Insider News & Updates –</strong> Be the first to know about major market moves and project announcements.</li>
							<li><strong>Pro Tips & Strategies –</strong> Learn proven trading strategies used by seasoned traders.</li>
							<li><strong>Early Airdrop & ICO Alerts –</strong> Get notified before the crowd.</li>
							<li><strong>Priority Q&A Support –</strong> Direct interaction with experts for quick answers.</li>
						</ul>
						
						<h2>Special Launch Offer</h2>
						
						<p>While we’re putting the finishing touches on our premium experience, you can join our Free Telegram Channel today and still get value-packed market updates.</p>
						
						<h2>Exclusive Bonus:</h2>
						
						<p>The first 50 members who join our free channel now will get 1 month of FREE Premium Access when we launch – no strings attached.</p>
						
						<h3>Join the Free Channel Now & Secure Your Spot!</h3>
						
						<div className="btn_mainsec">
							<a className="btn_style" href="https://t.me/coinviews144" target="_blank">Join Now</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

);
};

export default Plans;